import { InjectionToken } from '@angular/core';

export interface AnalyticsConfig {
    enabled: boolean;
    measurementId: string;
    debug: boolean;
}

export const ANALYTICS_CONFIG = new InjectionToken<AnalyticsConfig>('ANALYTICS_CONFIG');

declare global {
    interface Window {
        dataLayer?: unknown[];
        gtag?: (...args: unknown[]) => void;
    }
}
